module.exports = __webpack_public_path__ + "img/grocery-page.564b591f.png";